export enum PurchaseOrderStatus {
  DRAFT = 'DRAFT',
  SENT = 'SENT', 
  RECEIVED = 'RECEIVED',
  CANCELLED = 'CANCELLED'
}

export enum GoodsReceivedStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED'
}

export interface PurchaseOrderItem {
  id?: number;
  po_id?: number;
  /** Absent after the catalog line was deleted while the PO was received/cancelled. */
  vendor_product_id?: number | null;
  product_id?: number | null;
  vendor_product?: {
    id: number;
    name: string;
    vendor_product_code?: string | null;
    unit_of_measure?: string;
  };
  product?: {
    id: number;
    name: string;
    sku: string;
    unit_price: number;
  };
  quantity: number;
  unit_price: number;
  total_price: number;
  received_quantity: number;
}

export interface PurchaseOrder {
  id?: number;
  po_number?: string;
  vendor_id: number;
  vendor?: {
    id: number;
    name: string;
    contact_email: string;
    contact_phone: string;
  };
  location_id: number;
  location?: {
    id: number;
    name: string;
    address: string;
  };
  created_by?: number;
  created_by_user?: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
  };
  order_date: string;
  expected_delivery_date?: string;
  status: PurchaseOrderStatus;
  total_amount: number;
  notes?: string;
  created_at?: string;
  updated_at?: string;
  items: PurchaseOrderItem[];
}

export interface PurchaseOrderCreate {
  vendor_id: number;
  location_id: number;
  order_date: string;
  expected_delivery_date?: string;
  notes?: string;
  items: {
    vendor_product_id: number;
    quantity: number;
    unit_price: number;
  }[];
}

export interface PurchaseOrderUpdate {
  vendor_id?: number;
  location_id?: number;
  order_date?: string;
  expected_delivery_date?: string;
  status?: PurchaseOrderStatus;
  notes?: string;
  items?: {
    vendor_product_id: number;
    quantity: number;
    unit_price: number;
  }[];
}

export interface GoodsReceivedItem {
  id?: number;
  grpo_id?: number;
  po_item_id: number;
  product_id?: number;
  product?: {
    id: number;
    name: string;
    sku: string;
  };
  ordered_quantity: number;
  received_quantity: number;
  unit_price: number;
  total_price: number;
  manufacture_date?: string;
  expiry_date?: string;
}

export interface GoodsReceived {
  id?: number;
  grpo_number?: string;
  po_id: number;
  purchase_order?: PurchaseOrder;
  receipt_number?: string;
  received_date: string;
  received_by?: number;
  received_by_user?: {
    id: number;
    first_name: string;
    last_name: string;
  };
  total_amount: number;
  invoice_number?: string;
  status: GoodsReceivedStatus;
  notes?: string;
  created_at?: string;
  updated_at?: string;
  items: GoodsReceivedItem[];
}

export interface GoodsReceivedCreate {
  po_id: number;
  receipt_number?: string;
  received_date: string;
  invoice_number?: string;
  notes?: string;
  items: {
    po_item_id: number;
    product_id?: number;
    ordered_quantity: number;
    received_quantity: number;
    unit_price: number;
    manufacture_date?: string;
    expiry_date?: string;
  }[];
}

export interface PurchaseOrderFilters {
  status?: PurchaseOrderStatus;
  location_id?: number;
  vendor_id?: number;
  date_from?: string;
  date_to?: string;
  search?: string;
}

export interface PurchaseOrderStats {
  total_orders: number;
  draft_orders: number;
  sent_orders: number;
  received_orders: number;
  cancelled_orders: number;
  total_amount: number;
  pending_amount: number;
}